<template>
  <div class="baidumap">
    <div id="allmap">
<!--      <baidu-map  @click="paintPolyline" :center="{lng: 116.404, lat: 39.915}" :zoom="15">-->
<!--        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>-->
<!--      </baidu-map>-->
      <baidu-map style="width: 100%;height: 100%" class="map" :center="{lat:lat,lng:lng}" :zoom="15">
        <bm-info-window :position="{lat:lat,lng:lng}" :title="mtitle" :show="infoWindow.show"  @open="infoWindowOpen">
          <p >地址：{{ mdesc }}</p>
          <p >电话：{{ mtell }}</p>
        </bm-info-window>
      </baidu-map>
    </div>
  </div>
</template>

<script>
export default {
  name: 'baidumap',
  props:{
    mtitle:null,
    mdesc:null,
    mtell:null,
    lat: 34.220635,
    lng: 108.951439
  },
  data() {
    return {
      zoom: 1,
      infoWindow: {
        show: true,
        contents: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
      }
    }
  },
  mounted() {
    this.lng = 34.240977
    this.lat = 108.900274
    this.zoom = 15
  },
  methods:{
    paintPolyline(e){
      console.dir(e);
    },
    infoWindowClose (e) {
      this.infoWindow.show = false
    },
    infoWindowOpen (e) {
      this.infoWindow.show = true
    },
    clear () {
      this.infoWindow.contents = ''
    }
  }
}
</script>

<style scoped>
.baidumap{
  width: 100%;
  height: 870px;
  box-sizing: border-box;
}
#allmap{
  width: 100%;
  height: 100%;
}


</style>



// WEBPACK FOOTER //
// src/components/views/baidumap.vue